import { useState } from "react";
import { X } from "lucide-react";
import { Reveal } from "../Reveal";
import { Badge } from "../Pill";

export default function Gallery({ items }) {
  const [selected, setSelected] = useState(null);

  return (
    <section data-testid="gallery-section" className="bg-blush py-24 md:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="text-center"><Badge tone="ink">Real Weddings, Real Muses</Badge></Reveal>
        <Reveal delay={0.1} className="text-center">
          <h2 className="mt-6 font-display uppercase text-4xl md:text-5xl lg:text-6xl text-ink leading-[0.98]">
            Curated wedding highlights
          </h2>
        </Reveal>
        <Reveal delay={0.2} className="text-center">
          <p className="mt-5 max-w-xl mx-auto text-neutral-600">
            Couples, couture and ceremonies from our recent coverage. Tap any frame to view it in full.
          </p>
        </Reveal>

        <div className="mt-16 columns-2 md:columns-3 gap-4 md:gap-6" data-testid="gallery-grid">
          {items.map((g, idx) => (
            <Reveal key={idx} delay={0.04 * (idx % 6)} className="break-inside-avoid mb-4 md:mb-6">
              <button
                onClick={() => setSelected(g)}
                data-testid={`gallery-item-${idx}`}
                className="group block w-full text-left"
              >
                <div className="overflow-hidden rounded-[1.75rem]">
                  <img
                    src={g.src}
                    alt={g.caption || "Wedding highlight"}
                    loading="lazy"
                    className="w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
                  />
                </div>
                {g.caption && (
                  <p className="mt-3 font-elegant italic text-base text-ink/60">{g.caption}</p>
                )}
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      {selected && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[60] bg-ink/90 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={() => setSelected(null)}
        >
          <button
            data-testid="gallery-lightbox-close"
            onClick={() => setSelected(null)}
            className="absolute top-6 right-6 w-11 h-11 rounded-full bg-cream text-ink flex items-center justify-center hover:bg-champagne transition-colors duration-300"
            aria-label="Close"
          >
            <X size={18} />
          </button>
          <figure className="max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={selected.src} alt={selected.caption || "Wedding highlight"} className="w-full max-h-[80vh] object-contain rounded-[1.5rem]" />
            {selected.caption && (
              <figcaption className="mt-4 text-center text-[10px] font-bold uppercase tracking-[0.25em] text-champagne">{selected.caption}</figcaption>
            )}
          </figure>
        </div>
      )}
    </section>
  );
}
